<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    :class="{
      'brand-message--blackfriday': $store.state.isBlackFriday,
      'brand-message--christmas': $store.state.isChristmas,
    }"
    class="brand-message"
  >
    <div class="container">
      <div v-html="homeSlogan"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    homeSlogan: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.brand-message {
  padding: 12px 0 13px;
  font-size: 15px;
  background-color: $v4_color_yellow;
  color: $v4_color_blue;
  text-align: center;

  .brand-message__alt {
    font-weight: bold;
    color: $v4_color_primary;
  }

  &--blackfriday {
    background-color: $black_friday_color_primary;
    color: white !important;
    a {
      color: white;
    }
  }

  &--christmas {
    background-color: $christmas_color_primary !important;
    color: white !important;
    a {
      color: white;
    }
  }
}

@media (min-width: $v4_desktop) {
  .brand-message {
    padding: 20px 0 21px;
    font-size: 20px;
  }
}
</style>
